import React from "react";
import { Box, Typography, Chip } from "@mui/material";

export default function PanelHeader(props) {
  const { title, subtitle, statusChip = null } = props;
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
      <Box>
        <Typography variant="h6" fontWeight="bold">{title}</Typography>
        <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
      </Box>
      {statusChip}
    </Box>
  );
}
